import * as React from 'react';
import { getConfig, getDeatiledFeature } from '../config';
import { escape } from '../utils/component/helpers';
import { logCreativeLoad, logCreativeClick } from '../utils/logger';
import { useEffect } from 'react';

type Props = {
    id: string;
};

type MarketContentDesignExperimentVariants =
    | undefined
    | 'control'
    | 'challengerLargeTitleVariant1'
    | 'challengerNoLogoVariant2';

export function ContentMarketing(props: Props) {
    const { id } = props;
    const contentMarketing = getConfig()?.contentMarketing;

    const marketContentDesignExperiment = getDeatiledFeature(
        'marketContentDesignExperiment',
    );

    const currentVariant: MarketContentDesignExperimentVariants =
        marketContentDesignExperiment?.enabled
            ? (marketContentDesignExperiment?.payload
                  ?.value as MarketContentDesignExperimentVariants)
            : undefined;

    useEffect(() => {
        if (document) {
            logCreativeLoad(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentMarketing, id]);

    if (contentMarketing) {
        const escapedImgUrl = escape(contentMarketing.image.url);
        const escapedIconUrl = escape(contentMarketing.icon.url);
        const escapedSponsor = escape(contentMarketing.sponsor);
        const escapedHref = escape(contentMarketing.href);
        const escapedTitle = escape(contentMarketing.title);
        const escapedText = escape(contentMarketing.text);

        // Use this in both cases of the experiment
        const largeTitleCondition =
            currentVariant === 'challengerLargeTitleVariant1' ||
            currentVariant === 'challengerNoLogoVariant2'
                ? 'text-34 height-41 font-normal'
                : 'text-22 height-28 font-normal';

        // Use this only for the noLogo condition
        const noLogoCondition = currentVariant === 'challengerNoLogoVariant2';

        const html = `
            <article class="relative mt-24 mx-16 mb-auto sm:mb-24 cursor-pointer overflow-hidden relative transition-all outline-none f-card rounded-8" tabindex="0">
                <button class="sr-only" tabindex="-1">Velg</button>
                <div class="f-card-outline absolute rounded-8 inset-0 transition-all border-2 border-transparent"></div>
                <div aria-owns="title_id"></div>
                <img alt="Annonsebilde" class="h-290 w-full object-cover" src="${escapedImgUrl}">
                <p class="absolute top-16 left-16 bg-bluegray-50 p-4 rounded-4 text-12">Annonsørinnhold</p>
                <div class="flex top-16 left-16 items-center">
                    ${
                        noLogoCondition
                            ? ''
                            : `<img alt="${escapedSponsor}" class="h-24 ml-16 mt-16" src="${escapedIconUrl}">`
                    }
                    <div class="static mt-16 ml-16 text-12 height-16 text-gray-400 items-center">${escapedSponsor}</div>
                </div>
                <h3 class="${largeTitleCondition} text-gray-400 ml-16 mt-16 mr-16" id="title_id">
                    <a class="link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring" href="${escapedHref}" target="_blank" title="${escapedTitle}">
                        <span aria-hidden="true" class="inset-0 absolute"></span>${escapedTitle}
                    </a>
                </h3>
                <p class="text-14 text-gray-400 mb-4 ml-16 mb-16 mr-16">${escapedText}</p>
            </article>`;

        return (
            <div
                onClick={() =>
                    logCreativeClick(id, escapedSponsor, escapedHref)
                }
                id={id}
                dangerouslySetInnerHTML={{ __html: html }}
            />
        );
    }
    return null;
}
